<template>
    <div class="page-wrapper">
        <div class="subject-details-wrapper">

            <div class="subject-classify-wrapper">
                <div class="subject-classify" >
                    <div v-if="subjectData.blockContainerItems && subjectData.blockContainerItems.length" class="subject-classify-title clearfix">
                        <div class="title">{{subjectData.name}}</div>

                        
                    </div>
                    <div v-if="subjectData.blockContainerItems && subjectData.blockContainerItems.length">
                        <NewsList v-if="isPhone" :list="subjectData.blockContainerItems" />
                        <NewsList v-else :list="subjectData.blockContainerItems.slice(0, 12)" :type="2" :subjectId="id" :skId="$Common.Base64.encode(subjectData.id)" />
                    </div>
                </div>
            </div>
        </div>
        <div v-show="isLoading || lastDataId" class="loadMore">
            <div class="loadMoreInner">{{lastDataId == -1 ? '已经到底了' : '加载更多'}}</div>
        </div>
        <GoHome v-if="isPhone" />
    </div>
</template>
<script>
import SubjectSpecial from "@/components/SubjectSpecial";
import NewsList from '@/components/NewsList';
import GoHome from '@/components/GoHome.vue';
import { mapMutations, mapState } from 'vuex';
export default {
    name: 'SubjectList',
    data() {
        return {
            page: 1,
            id: null,
            sData: null,
            list: [],
            isLoading: false,
            lastDataId: null,
            errorImg: `this.parentNode.style.backgroundImage = 'url("${require('./../assets/img/default.png')}")'`, // 头图加载失败
            subjectData:{}
        }
    },
    components: {
        NewsList,
        GoHome
    },
    created() {
        // 获取列表数据
        this.id = this.$route.params.id;
        this.getDetail();
    },
    watch: {
        $route(val) {
            if(val.params.id && this.id != val.params.id) {
                this.setInit();
                this.id = val.params.id;
                this.getDetail()
            }
        }
    },
    methods: {
        ...mapMutations(['setLoadingShow','setIsSubject','setIsSpecial']),
        getDetail() {
            if(!this.$Common.Base64.decode(this.id)) {
                return;
            }
            const params = {
                classifyId: this.$Common.Base64.decode(this.id),
            }

            if(this.isPhone){
                params.pageSize = this.pageSize
                if (this.lastDataId) {
                    params.lastDataId = this.lastDataId
                }
            } 
            
            
            this.isLoading = true;
            this.$axios.post(this.$ApiInfo.getSubjectChannelMore,params).then(res => {
                this.subjectData = res.item
                this.subjectData.blockContainerItems = this.subjectData.blockContainerItems.map(childItem => ({...childItem,images:{img169:childItem.imgUrl}}))
                if(this.isPhone){
                    this.lastDataId = res.lastDataId
                    this.$nextTick(()=> {
                        let footerHeight = 0;
                        document.querySelector('.footer-wrapper') && document.querySelector('.footer-wrapper').clientHeight > 0 && (footerHeight = document.querySelector('.footer-wrapper').clientHeight - 50)
                        this.$Common.loadScroll(footerHeight, this.update)
                    })
                    res.share && this.$Common.onShare({
                        shareTitle: res.share.shareTitle,
                        shareBrief: res.share.shareBrief,
                        shareUrl: window.location.href,
                        // shareImg: res.share.shareImg
                    })
                }
                this.setLoadingShow(false);
                this.isLoading = false;
            })
        },
        update() {
            if(this.isLoading || this.lastDataId == -1 || !this.$Common.Base64.decode(this.id)) {
                return;
            }
            const params = {
                classifyId: this.$Common.Base64.decode(this.id),
            }

            if(this.isPhone){
                params.pageSize = this.pageSize
                if (this.lastDataId) {
                    params.lastDataId = this.lastDataId
                }
            } 
            this.isLoading = true;
            this.$axios.post(this.$ApiInfo.getSubjectChannelMore,params).then(res => {
                this.isLoading = false;
                if(this.isPhone) this.lastDataId = res.lastDataId
                let list = res.item.blockContainerItems
                list = list.map(childItem => ({...childItem,images:{img169:childItem.imgUrl}}))
                this.subjectData.blockContainerItems = this.subjectData.blockContainerItems.concat(list)
            })
        },
  
        setInit() {
            this.id = null;
            this.sData = null;
            this.list = [];
            this.isLoading = false;
            this.lastDataId = null;
        }
    },
    computed: {
        isPhone() {
            return this.$Common.Attribute.isMb();
        },
        pageSize() {
            return this.isPhone ? 20 : 45;
        }
    },
}
</script>
<style lang="less" scoped>
.subject-details-wrapper {
    width: 100%;
    .subject-img-title {
        width: 100%;
        height: auto;
        margin-bottom: 1.5rem;
        .img {
            display: block;
            width: 100%;
            height: 12.75rem;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            background-image: url('./../assets/img/default.png');
        }
        .text {
            padding: 1.25rem 1.5625rem;
            background: #fff;
            color: #333333;
            .title {
                font-size: 1.375rem;
                line-height: 1.875rem;
            }
            .brief {
                font-size: 1.25rem;
                line-height: 1.75rem;
            }
        }
    }
    .subject-classify-wrapper {
        .subject-classify {
            .subject-classify-title {
                color: #006df1;
                border-left: 0.1875rem solid #006df1;
                text-indent: .5em;
                margin-bottom: 0.875rem;
                line-height: 1.125rem;
                &.isSpecial{
                   color: #385C40;
                   border-left: 0.1875rem solid #385C40; 
                    .seeMore {
                        color: #385C40; 
                    }
                }
                .title {
                    float: left;
                }
                .seeMore {
                  font-size: 0.625rem;
                  color:#006DF1;
                  float: right;
                  img {
                    width: 0.3125rem;
                    height: 0.4375rem;
                  }
                }
            }
        }
    }
}

.wap-wrapper {
    .subject-details-wrapper {
        width: 100%;
        .subject-img-title {
            width: 100%;
            height: auto;
            margin-bottom: 5.333vw;
            position: relative;
            img {
                display: block;
                width: 100%;
                height: 100%;
            }
            .text {
                width: 100%;
                box-sizing: border-box;
                padding: 6.8vw 4vw 4.4vw;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
                color: #fff;
                position: absolute;
                bottom: 0;
                .title {
                    display: none;
                }
                .brief {
                    font-size: 4.533vw;
                    line-height: 6.4vw;
                }
            }
        }
        .subject-classify-wrapper {
            .subject-classify {
                .subject-classify-title {
                    color: #006df1;
                    margin-bottom: 3.067vw;
                    margin-top: 3.067vw;
                    line-height: 4.8vw;
                    font-size: 4.8vw;
                    padding: 0 4vw;
                    box-sizing: border-box;
                    border-left: none;
                    &.isSpecial{
                        color: #385C40;
                        padding-top:4.4vw;
                    }
                    .title {
                        border-left: 2px solid #006df1;
                        text-indent: .5em;
                        float: left;
                    }
                    &.isSpecial{
                        .title {
                           border-left: 2px solid #385C40; 
                        }
                    }
                    .seeMore {
                        font-size: 3.2vw;
                        line-height: 4.8vw;
                        float: right;
                        color:#666666;
                        img {
                            width: 1.6vw;
                            height: 2.667vw;
                        }
                    }
                }
            }
        }
    }
}
</style>